import { graphql } from "msw";
import { generateRemoveItemMock } from "../utilities/generateRemoveItemMock";
import {
  MoveItemFromCartToWishlistMutationVariables,
  MoveItemFromCartToWishlistMutation,
} from "@cart-app/generated/graphql";
import { ITEM_ID_THAT_WILL_THROW_ERROR } from "@cart-app/mocks/constants";

export const handler = graphql.mutation<
  MoveItemFromCartToWishlistMutation,
  MoveItemFromCartToWishlistMutationVariables
>("MoveItemFromCartToWishlist", (req, res, ctx) => {
  const { id } = req.variables;

  if (id == ITEM_ID_THAT_WILL_THROW_ERROR) {
    return res(
      ctx.data({
        moveItemFromCartToWishlist: {
          __typename: "UserError" as const,
          message: "Item already added to wishlist.",
        },
      })
    );
  }

  return res(
    ctx.data({
      moveItemFromCartToWishlist: {
        ...generateRemoveItemMock({
          id,
        }),
      },
    })
  );
});
